<mat-sidenav-container>
  <mat-sidenav-content>
    <div class="page color">
      <div class="main">
        <img class="logos" [src]="logos" width="100%" alt="logos">

        @if (robot) {
          <h1>Advertencia</h1>
          <div class="warning-code">TRÁFICO INUSUAL</div>
          <h2 class="warning">Necesitamos validar que eres una persona</h2>
          <p class="lead">El servidor no puede atender temporalmente su solicitud debido a un tráfico inusual
            procedente de tu red de computadoras.
          </p>
          <p class="action text-center">Para confirmar que eres una persona y no un robot, resuelve el reCAPTCHA. Cuando lo resuelvas, desaparecerá el mensaje y podrás volver a usar la pagina.</p>
          <div class="help-actions text-center">
            <re-captcha [theme]="darkMode?'dark':'light'" #captcha [siteKey]="siteKey"
            (resolved)="resolved($event)" errorMode="handled"></re-captcha>
          </div>
        } @else {
          <h1>Error del Servidor</h1>
          <div class="error-code">503</div>
          <h2>Servicio Temporalmente No Disponible</h2>
          <p class="lead">El servidor no puede atender temporalmente su solicitud debido a un tiempo de
            inactividad por mantenimiento o problemas de capacidad. Por favor, inténtelo de nuevo más tarde.
          </p>
          <hr />
          <p>Esto es lo que puedes hacer:</p>
          <div class="help-actions">
            <a mat-stroked-button color="primary" href="javascript:location.reload();">Recargar Página</a>
            <a mat-stroked-button color="primary" href="javascript:history.back();">Volver a la Página
            Anterior</a>
            <a mat-stroked-button color="primary" href="/">Página de Inicio</a>
          </div>
        }
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>